import LinkToDocusaurus from '../LinkToDocusaurus'
import { testResults } from '../../docs-routes'

const LinkToTestResultsDoc = () =>
  <LinkToDocusaurus path={testResults}>
    Learn more about Test Results
  </LinkToDocusaurus>

export default LinkToTestResultsDoc
